export const CLASSROOM_ADD_ON_START = '/apps/universal-embed/google-classroom/start';
export const CLASSROOM_ADD_ON_CREATION_MESSAGE = 'NEWSELA_USER_CREATION';
